/*
 * File: CreatedBySearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 10 Dec 2021 2:23:05 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterCreatedByUserFullName } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

export const CreatedBySearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterCreatedByUserFullName(ev.target.value));
  }, 500);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} placeholder="Created By" width={150} />
    </Space>
  );
};
